import { ComplaintsType } from "../data/types";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

export function RecentComplaints({
  complaints,
}: {
  complaints: ComplaintsType[];
}) {
  return (
    <div className="space-y-8">
      {complaints.map((complaint) => (
        <div key={complaint.id} className="flex items-center">
          <Avatar className="h-9 w-9">
            <AvatarImage src={`/avatars/${complaint.id}.png`} alt="Avatar" />
            <AvatarFallback>
              {complaint.firstName.substring(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="ml-4 space-y-1">
            <p className="text-sm font-medium leading-none">
              {complaint.firstName}
            </p>
            <p className="text-sm text-muted-foreground">{complaint.email}</p>
          </div>
          <div className="ml-auto font-medium">
            {new Date(complaint.createdAt).toLocaleDateString("fr-FR")}
          </div>
        </div>
      ))}
    </div>
  );
}
